module.exports = __webpack_public_path__ + "static/media/icon-dollar.117e0c39.svg";